import React, { useState, useEffect } from "react";
import { Table, Button, Typography, Modal, Form, Select, message } from "antd";
import "./Styles/Dashboard.css";
import OrderDetailsModal from "./OrderDetailsModal"; // Import the OrderDetailsModal component
import moment from "moment"; // Import Moment library for date formatting
import jsPDF from "jspdf";
import "jspdf-autotable";
const { Link } = Typography;
const { Option } = Select;
const { confirm } = Modal; // Import Modal.confirm

const Dashboard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);
  const [staffData, setStaffData] = useState([]);

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);
    fetchpackedOrders(VendorId);
  }, [refreshTrigger]);
  const fetchpackedOrders = async (VendorId) => {
    console.log("Fetching packed orders for vendor:", VendorId);
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/total_packed_orders_admin",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        setOrderData([]);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched packed orders:", data);
      setOrderData(data);
    } catch (error) {
      console.error("Error fetching packed orders:", error.message);
      // You might want to set some error state here to display to the user
    }
  };

  const markOrderReadyForShipment = async (orderId) => {
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/order_vendor_details",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendorId, orderId: orderId.order_id }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to mark order as ready for shipment");
      }
      setRefreshTrigger((prev) => prev + 1); // Trigger a re-fetch
      message.success("Order marked as ready for shipment successfully");
    } catch (error) {
      console.error("Error marking order as ready for shipment:", error);
      message.error("Error marking order as ready for shipment");
    }
  };

  const handleOrderDetails = async (record) => {
    console.log(vendorId);
    try {
      const response = await fetch("https://app-tl2d3sc25q-uc.a.run.app/api/order_details", {
        method: "POST", // Use POST if you are sending data in the body
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vendorId: record.vendor_id,
          orderId: record.order_id,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch order details");
      }
      const data = await response.json();
      console.log("Order Details:", data);
      // Display modal with order details
      setSelectedOrder(data); // Store order details in state
      setIsModalVisible(true); // Show modal
    } catch (error) {
      console.error("Error fetching order details:", error);
      // Handle error state if needed
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "order_id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "orderId",
      render: (text, record) => (
        <Link onClick={() => handleOrderDetails(record)}>{text}</Link>
      ),
    },
    {
      title: "Packed Date & Time",
      dataIndex: "packed_time",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Vendor Name",
      key: "vendor_name",
      render: (text, record) => `${record.vendor_name}`,
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Customer Name",
      key: "customer_name",
      render: (text, record) =>
        `${record.shipping_first_name} ${record.shipping_last_name}`,
    },
    {
      title: "Customer Phone",
      dataIndex: "shipping_phone",
      key: "shipping_phone",
    },
  ];

  const showAssignModal2 = (record) => {
    confirm({
      title: "Are you sure you want to Shipment this order?",
      content: `Order ID: ${record.order_id}`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: () => markOrderReadyForShipment(record),
    });
  };

  const formatDate = (dateString) => {
    console.log("come");
    // Use Moment.js or JavaScript Date object to format the date
    const formattedDate = moment(dateString).format("DD:MM:YYYY hh:mm A");
    return formattedDate;
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
    form.resetFields();
  };

  const handleOk2 = () => {
    form
      .validateFields()
      .then((values) => {
        const selectedStaff = staffData.find(
          (staff) => staff.id === values.staffId
        );
        assignStaffToOrder(
          values.staffId,
          selectedStaff.name,
          selectedOrder2.customer_name,
          selectedOrder2.customer_phone,
          selectedOrder2.order_id
        );
        setIsModalVisible2(false);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const assignStaffToOrder = async (
    staffId,
    staffName,
    customerName,
    customerPhone,
    orderId
  ) => {
    try {
      const response = await fetch(
        `https://app-nm5xb3nmya-uc.a.run.app/api/assign_accountant`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            roll_acct: staffId,
            order_id: orderId,
            accountant_name: staffName,
            customer_name: customerName,
            customer_phone: customerPhone,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to assign staff to order");
      }
      message.success("Staff assigned successfully");
    } catch (error) {
      console.error("Error assigning staff to order:", error);
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const record = {
      customer_name: "John Doe",
      order_date: "2024-08-05",
      order_id: "INV20240805",
    };

    // Add company details
    doc.setFontSize(12);
    doc.text("Aptope CLOTHING COMPANY", 14, 15);
    doc.setFontSize(10);
    doc.text("1st Floor, 5/129 Avinashilingampalayam", 14, 20);
    doc.text("Palangarai Village, Avinashi", 14, 25);
    doc.text("Thirumuruganpoondi, Tiruppur", 14, 30);
    doc.text("Tamil Nadu, 641654", 14, 35);
    doc.text("GST: 33AEPPU3730E1ZG", 14, 40);

    // Add customer details
    doc.text("BILLING ADDRESS:", 120, 15);
    doc.text(record.customer_name, 120, 20);
    doc.text("7 Fresh Bakery, Valayashettiyur,", 120, 25);
    doc.text("Erode, Tamil Nadu, 637107", 120, 30);

    // Add invoice details
    doc.text(`Invoice Date: ${formatDate(record.order_date)}`, 14, 50);
    doc.text(`Invoice Number: ${record.order_id}`, 14, 55);
    doc.text(`Order Date: ${formatDate(record.order_date)}`, 14, 60);
    doc.text(`Order Number: ${record.order_id}`, 14, 65);

    // Add table
    doc.autoTable({
      startY: 75,
      head: [
        [
          "S.No",
          "Description",
          "Unit Price",
          "Qty",
          "Net Amount",
          "Tax Rate",
          "Tax Amount",
          "Total Amount",
        ],
      ],
      body: [
        [
          "1",
          "Trendy Men's Five Sleeve Printed T-shirt – XL",
          "269.78",
          "1",
          "269.78",
          "18%",
          "59.22",
          "329",
        ],
        ["", "Shipping Charges", "41", "1", "41", "18%", "9", "50"],
      ],
      theme: "grid",
    });

    // Add total
    doc.text("Total: Rs. 379", 14, doc.previousAutoTable.finalY + 10);
    doc.text(
      "Amount in Words: Three Hundred Seventy-nine only",
      14,
      doc.previousAutoTable.finalY + 20
    );

    // Save the PDF
    doc.save(`Invoice_${record.order_id}.pdf`);
  };

  

  return (
    <div className="dashboard-container">
      <Table
        columns={columns}
        dataSource={orderData}
        rowKey="id"
        scroll={{ x: 1200, y: 500 }}
      />

      <OrderDetailsModal
        visible={isModalVisible}
        order={selectedOrder}
        staffData={staffData}
        onCancel={handleCancel}
      />

      <Modal
        title="Assign Order"
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="staffId"
            label="Select Staff"
            rules={[
              { required: true, message: "Please select a staff member" },
            ]}
          >
            <Select placeholder="Select a staff member">
              {staffData.map((staff) => (
                <Option key={staff.id} value={staff.id}>
                  {staff.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Dashboard;
